import axiosInstance from "./AxiosInstance";

export function loginApi(data) {
    return axiosInstance.post(`api/auth/login`, data);
}

export function logoutApi() {
    return axiosInstance.get(`api/auth/logout`);
}

export function whoami() {
    return axiosInstance.get('api/auth/who_am_i');
}